<template>
  <section v-intersect="onIntersect" :class="{fade: isIntersecting}" class="section contact" id="contact">
    <div class="section-wrapper">
      <h2 :class="{expandTitle: isIntersecting}" class="section-title">CONTACT</h2>
      <div class="underline"></div>
      <div class="content-wrapper">
        <div class="content">
          <!-- <h3 class="content-title">アクセス・連絡先</h3> -->
          <h4 class="description-title">OPEN</h4>
          <p>
            <font-awesome-icon :icon="['fas', 'cut']"/>
            9:00 - 18:00
          </p>
          <p>定休日：火曜 +α</p>
          <h4 class="description-title">TEL</h4>
          <p><a class="add-underline" href="tel:09018281644">
            <font-awesome-icon
              v-observe-visibility="{
                callback: visibilityChanged,
              }"
              :class="{jump:isVisible}" 
              :icon="['fas', 'phone-square']"
            />
            090-1828-1644
          </a></p>
          <h4 class="description-title">ADDRESS</h4>
          <p>
            <font-awesome-icon :icon="['fas', 'clinic-medical']"/>
            長野県佐久市甲2152-7
          </p>
          <div class="google-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3217.289578480278!2d138.40000595176738!3d36.25674797996609!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601dca794de1d83f%3A0x5a62213ec42c74bc!2zRG9nU2Fsb25GcmVl44OJ44OD44Kw44K144Ot44Oz44OV44Oq44O8!5e0!3m2!1sja!2sjp!4v1571984444321!5m2!1sja!2sjp" width="100%" height="auto" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'contact',
  data(){
    return {
      isIntersecting: false,
      isVisible: false,
    }
  },
  methods: {
    visibilityChanged (isVisible) {
      this.isVisible = isVisible
    },
    onIntersect (entries) {
      this.isIntersecting = entries[0].isIntersecting
    },
  },
}
</script>

<style lang="scss">
  .contact {
    .google-map {
      height: 0;
      overflow: hidden;
      padding-bottom: 56.25%;
      position: relative;
      iframe {
        position: absolute;
        left:0;
        top: 0;
        height: 100%;
        width: 100%;
      }
    }
  }
  .jump {
  animation: jump-animation 1.0s ease-in-out 0s infinite normal;
}

@keyframes jump-animation {
  0% {transform: scaleY(0.9);}
  10% {transform: translateY(0px) scaleY(1.0);}
  25% {transform: translateY(-10px);}
  50% {transform: translateY(1px) scaleY(0.9);}
  75% {transform: translateY(-3px);}
  90% {transform: translateY(0px);}
  100% {transform: scaleY(0.9);}
}
</style>